import React from 'react';

import CN from './NewBanner.module.scss';

const NewBanner = () => (
  <div data-bem="NewBanner" className={CN.banner}>
    NEW!
  </div>
);

export default NewBanner;
